// extracted by mini-css-extract-plugin
export default {"menuLink":"dropDownMenu_menuLink__kVSkp","dropMenu":"dropDownMenu_dropMenu__bOuEX","dropdownSlideIn":"dropDownMenu_dropdownSlideIn__SMMoa"};